export const VIEW_CARD_FORM = 'CARD_FORM';
export const VIEW_LINKED_CARDS = 'LINKED_CARDS';